/***
 * Created on 2023/12/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useRef, useState} from 'react';
import PasswordInput from "../form/password_input";
import ModalDialog from "./modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../service/api";
import md5 from "blueimp-md5";
import {useCaptcha} from "../../../hook/captcha";


function VerifyPassword({dispatch, warningContents, ...props}) {
    const { t } = useTranslation();
    const [inputValues, setInputValues] = useState({
        password: ''
    });
    const [passInputValid, setPassInputValid] = useState(false);
    const modalRef = useRef();

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost(`/ajax/authenticate_user_password`, data),
        onSuccess: data => {
            dispatch(data);
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onSubmit = async () => {
        const data = {
            ...inputValues,
            password: md5(inputValues.password)
        }
        await verifyMutation.mutateAsync(data);
    }

    const onChange = (e, callback, name=null, value=null) => {
        if (callback && typeof callback === 'function') {
            callback(e);
        }
        const _name = name ? name : e.target.name;
        const _value = value ? value: e.target.value;
        setInputValues(prev => {
            return {
                ...prev,
                [_name]: _value
            }
        })

        if (_value && _value.length > 0) {
            modalRef.current.disableSubmitButton(false);
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }

    const {Captcha, hasCaptcha, captchaValue, captchaError} = useCaptcha(onChange);

    return (
        <ModalDialog {...props} title={t('@Verify Password@')} submitText={t('@Edit@')} initDisableSubmit={true} submitAction={onSubmit} ref={modalRef}>
            <div className="dialog-content">
                <p>
                    {warningContents}
                </p>
                <br/>
                <PasswordInput
                    placeholder={t('@Password@')}
                    value={inputValues.password}
                    name="password"
                    onChange={onChange}
                    status={setPassInputValid}
                    compType="dialog"
                    required={true}/>

                { hasCaptcha && Captcha }
            </div>
        </ModalDialog>
    );
}

export default VerifyPassword;